module.exports = __webpack_public_path__ + "static/media/driver-vector-happy-5.116168e0.gif";